const FourOFour = () => {
    return (
        <div className="fourOFourContainer">
            <h1>404</h1>
            <h3>THE PAGE YOU ARE LOOKING FOR DOES NOT EXIST</h3>
        </div>
    )
}

export default FourOFour;